import { BudgetData } from "@routes/SingaporeBudget/utils/types";
import CustomError from "@src/app/components/Error/CustomError";
import { HttpStatusCode } from "axios";

import SingaporeBudget2024 from "./2024/SingaporeBudget2024";
import SingaporeBudget2025 from "./2025/SingaporeBudget2025";
import { isBudget2024Data, isBudget2025Data } from "./utils/helpers";

type SingaporeBudgetPageLayoutFactoryProps = {
  data: BudgetData;
};

const SingaporeBudgetPageLayoutFactory = ({
  data,
}: SingaporeBudgetPageLayoutFactoryProps): React.ReactElement => {
  if (isBudget2025Data(data)) {
    return <SingaporeBudget2025 {...data} />;
  }

  if (isBudget2024Data(data)) {
    return <SingaporeBudget2024 {...data} />;
  }

  return <CustomError statusCode={HttpStatusCode.NotFound} />;
};

export default SingaporeBudgetPageLayoutFactory;
